<template>
  <div class="cropper-box">
    <vueCropper
      ref="cropper"
      :img="option.img"
      :output-size="option.size"
      :output-type="option.outputType"
      :info="true"
      :full="option.full"
      :can-move="option.canMove"
      :can-move-box="option.canMoveBox"
      :fixed-box="option.fixedBox"
      :fixed="option.fixed"
      :fixed-number="option.fixedNumber"
      :original="option.original"
      :auto-crop="option.autoCrop"
      :auto-crop-width="option.autoCropWidth"
      :auto-crop-height="option.autoCropHeight"
      :center-box="option.centerBox"
      :high="option.high"
      :info-true="option.infoTrue"
      :max-img-size="option.maxImgSize"
      :enlarge="option.enlarge"
      :mode="option.mode"
      @realTime="realTime"
      @imgLoad="imgLoad"
      @cropMoving="cropMoving"
    />
  </div>

</template>

<script>
import VueCropper from 'vue-cropper/src/vue-cropper.vue'
import {uploadImgBase64} from '@/api/attachment'

export default {
  name: 'CropperImg',
  components: {
    VueCropper
  },
  props: {
    fixed: {
      type: Boolean,
      default: true
    },
    fixedNumber: {
      type: Array,
      default: function() {
        return [1, 1]
      }
    },
    image: {
      type: String,
      default: ''
    },
    selectFileName: {
      type: String,
      default: ''
    },
    centerBox: {
      type: Boolean,
      default: false
    }

  },
  data() {
    return {
      option: {
        img: 'http://cdn.xyxiao.cn/Landscape_2.jpg',
        size: 1,
        full: true,
        outputType: 'png',
        canMove: true,
        fixedBox: false,
        fixed: true,
        fixedNumber: [1, 1],
        original: false,
        canMoveBox: true,
        autoCrop: true,
        autoCropWidth: 0,
        autoCropHeight: 0,
        centerBox: false,
        high: false,
        cropData: {},
        enlarge: 1,
        mode: 'contain',
        maxImgSize: 2000,
        infoTrue: true
      }
    }
  },
  watch: {
    fixedNumber: {
      handler(newName, oldName) {
        this.option.fixedNumber = newName
      },
      immediate: true,
      deep: true
    },
    image: {
      handler(newName, oldName) {
        this.option.img = newName
      },
      immediate: true,
      deep: true
    },
    fixed: {
      handler(newVal, oldVal) {
        this.option.fixed = newVal
      },
      immediate: true,
      deep: true
    },
    centerBox: {
      handler(newVal, oldVal) {
        this.option.centerBox = newVal
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {

  },
  methods: {
    imgLoad(msg) {
      // console.log(msg)
    },
    realTime(data) {
      // console.log(data)
    },
    cropMoving(data) {
      this.option.cropData = data
    },
        // 新增：设置裁剪框信息
    setAutoCropInfo(info) {
      if (!this.$refs.cropper) return
      
      const { width, height } = info
      
      // 如果 width 和 height 都为 0，表示使用原图尺寸
      if (width === 0 && height === 0) {
        // 获取图片容器信息
        this.$refs.cropper.getCropData((data) => {
          // 使用 goAutoCrop 方法重新初始化裁剪框为全图
          this.$refs.cropper.goAutoCrop()
        })
      } else {
        // 设置指定的宽高
        this.option.autoCropWidth = width
        this.option.autoCropHeight = height
        
        // 刷新裁剪框
        this.$nextTick(() => {
          if (this.$refs.cropper) {
            this.$refs.cropper.goAutoCrop()
          }
        })
      }
    },
    finish() {
      // 上传截图到服务器
      this.$refs.cropper.getCropData(data => {
        var param = {}
        param.file = data
        param.fileExt = this.option.outputType
        param.fileName = this.selectFileName
        this.$emit('uploadingBase64', true)
        uploadImgBase64(param).then(response => {
          this.$emit('uploadingBase64', false)
          if (response.data) {
            this.$emit('uploadSucceed', response.data)
          } else {
            this.$message({
              message: response,
              type: 'error'
            })
          }
        }).catch(e => {
          this.$emit('uploadingBase64', false)
        })
      })
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .cropper-box {
    width: 100%;
    position: absolute;
    bottom: 0;
    top: 0;
  }
</style>
